import React from 'react';

function ServicesSection() {
  const services = [
    {
      banner: '/slide/8.jpg',
      title: 'Creating Job opportunities through Placement',
      description:
        'Ceyone Foundations acts as a link between the companies that offer jobs in various areas and the job-seekers. Ceyone Foundation also help reduce the clutter and streamline the manpower hunting for the companies no matter how big or small.',
    },
    {
      banner: '/slide/1.jpg',
      title: 'Center for entrepreneurship & Corporate learning',
      description:
        'The Center for entrepreneurship & Corporate learning is a premier flagship of Ceyone Foundations, engaged in training, consultancy, research, etc. in order to promote entrepreneurship and Skill Development.',
    },
    {
      banner: '/slide/11.jpg',
      title: 'Youth Empowerment',
      description:
        'We are dedicated to empowering youth to achieve their full economic potential by inspiring youth to become educated, change makers and leaders in the society & in their community.',
    },
    {
      banner: '/slide/10.jpg',
      title: 'Women Empowerment',
      description:
        'We are dedicated to empowering women to achieve their full economic potential by inspiring both women and child to become educated, change makers and leaders in the society & in their community.',
    },
    {
      banner: '/slide/9.jpg',
      title: 'Training & Skill upgradation',
      description:
        'Ceyone Foundations Training and skill upgradation offers immense benefits to professionals across job roles, industries and geographies. In competitive job markets, training and skill upgradation can play a key role in enhancing individuals career.',
    },
  ];

  return (
    <div className="bg-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg overflow-hidden flex flex-col transform transition-transform duration-300 hover:scale-105 hover:shadow-lg"
            >
              {/* Banner Image */}
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={service.banner}
                  alt={`${service.title} banner`}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
              </div>
              {/* Card Content */}
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4 flex-grow">
                  {service.description}
                </p>
                <a
                  href="/services"
                  className="text-pink-500 font-semibold hover:underline mt-auto transition-colors duration-300 hover:text-pink-700"
                >
                  Read More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServicesSection;